import { dodoChatTypes } from '../../constants/types';
import { $api } from '../../services/api';
import { query } from '../../utils/wrappers';

const { setConversations, setConversationMessages, setConversionRatingAndComment, clearConversationMessages } =
  dodoChatTypes.actions;

export const actions = {
  [setConversations]: async ({ commit }) => {
    return query({
      commit,
      api: $api.dodoChat.conversation.get({ pathParams: {}, queryParams: {} }),
      options: {
        loader: setConversations,
        promise: false,
        mutation: setConversations
      }
    });
  },

  [setConversationMessages]: async ({ commit }, { id }) => {
    return query({
      commit,
      api: $api.dodoChat.message.get({
        pathParams: {
          id
        },
        queryParams: {}
      }),
      options: {
        loader: setConversationMessages,
        promise: false,
        mutation: setConversationMessages
      }
    });
  },

  [setConversionRatingAndComment]: async ({ commit }, { conversation_id, rating, comment }) => {
    return query({
      commit,
      api: $api.dodoChat.feedback.post({ conversation_id, rating, comment }),
      options: {
        loader: setConversionRatingAndComment,
        promise: true
      }
    });
  },

  [clearConversationMessages]: async ({ commit }) => {
    commit(clearConversationMessages);
  }
};
